var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * GTM events triggered on site:
 *
 * @AC.Interaction.Search.open {}
 * @AC.Interaction.Search.close {}
 * @AC.Interaction.Search.complete { query: string }
 * @AC.Interaction.Email.click { email: string }
 * @AC.Interaction.Phone.click { phone: string }
 * @AC.Interaction.HeaderMenu.open { label: string }
 * @AC.Interaction.HeaderMenu.close { label: string }
 * @AC.Interaction.QuestionPopup.open {}
 * @AC.Interaction.QuestionPopup.close {}
 *
 * @AC.Visit.duration { duration: number }
 * @AC.Visit.scroll { amount: number }
 *
 * @AC.ContactRequest.Submit.success { formId: string|number }
 * @AC.ContactRequest.Submit.failure { formId: string|number, failureReason: string }
 */
/**
 *
 */
export function initGTMTracking() {
    window.dataLayer && window.dataLayer instanceof Array || (window.dataLayer = []);
    [].slice.apply(document.querySelectorAll('a[href^="tel:"]')).forEach(function (el) {
        el.addEventListener('click', function (event) {
            dispatchGtmEvent('AC.Interaction.Phone.click', {
                phone: el.href.replace('tel:', ''),
            });
        });
    });
    [30, 60, 120, 180, 300, 600].forEach(function (duration) {
        setTimeout(function () {
            dispatchGtmEvent('AC.Visit.duration', {
                duration: duration,
            });
        }, duration * 1000);
    });
    var scrollAmount = 0;
    var lastScrollOffset = window.pageYOffset;
    var firstScreenDispatched = false;
    var fullDocumentDispatched = false;
    var doubleDocumentDispatched = false;
    var scrollChecker = setInterval(function () {
        scrollAmount += Math.abs(window.pageYOffset - lastScrollOffset);
        lastScrollOffset = window.pageYOffset;
        if (!firstScreenDispatched && scrollAmount > window.innerHeight) {
            dispatchGtmEvent('AC.Visit.scroll', { amount: 'screen' });
            firstScreenDispatched = true;
        }
        else if (!fullDocumentDispatched && scrollAmount > document.body.scrollHeight - window.innerHeight) {
            dispatchGtmEvent('AC.Visit.scroll', { amount: 'page' });
            fullDocumentDispatched = true;
        }
        else if (!doubleDocumentDispatched && scrollAmount > document.body.scrollHeight * 2 - window.innerHeight) {
            dispatchGtmEvent('AC.Visit.scroll', { amount: 'page_2x' });
            doubleDocumentDispatched = true;
        }
        else if (firstScreenDispatched && fullDocumentDispatched && doubleDocumentDispatched) {
            window.clearInterval(scrollChecker);
        }
    }, 500);
    document.addEventListener('wpcf7mailsent', onContactForm7Submit);
    document.addEventListener('wpcf7mailfailed', onContactForm7Submit);
    document.addEventListener('wpcf7spam', onContactForm7Submit);
    document.addEventListener('wpcf7invalid', onContactForm7Submit);
    function onContactForm7Submit(event) {
        var type = event.type === 'wpcf7mailsent' ? 'success' : 'failure';
        var data = {
            formId: event.detail.contactFormId,
        };
        if (type !== 'success') {
            data.failureReason = (function () {
                switch (event.type) {
                    case 'wpcf7spam':
                        return 'Spam';
                    case 'wpcf7invalid':
                        return 'Invalid credentials';
                    case 'wpcf7mailfailed':
                    default:
                        return 'Failed to send e-mail';
                }
            })();
        }
        dispatchGtmEvent("AC.ContactRequest.submit.".concat(status), data);
    }
}
export function dispatchGtmEvent(event, data) {
    if (data === void 0) { data = {}; }
    window.dataLayer.push(__assign(__assign({}, data), { event: event }));
}
